import { render, staticRenderFns } from "./titleDetailInfoRow.vue?vue&type=template&id=435833a5&scoped=true"
import script from "./titleDetailInfoRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./titleDetailInfoRow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./titleDetailInfoRow.vue?vue&type=style&index=0&id=435833a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435833a5",
  null
  
)

export default component.exports